"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
function useUniqueId() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  const id = (0, _react.useId)();
  return `${prefix ? `${prefix}-` : ''}${id}`;
}
var _default = exports.default = useUniqueId;